import React from 'react';
import PropTypes from 'prop-types';
import UserStore from '../stores/UserStore';
import { withTranslation } from './ChildrenContext';

const AuthController = ({ t }) => {
    const isHaveAccess = UserStore.getAccess();
    const staticNames = (t && t.auth) || {};

    return (
        !isHaveAccess
            ? <div className="auth-controller-container">
                <p>{staticNames.rightsPhrase}.</p>
              </div>
            : null
    );
};

AuthController.propTypes = {
    t: PropTypes.object
};

export default withTranslation(AuthController);
